import { CHECK_PROMO_CODE_REQUEST, CHECK_PROMO_CODE_RESET } from "../types";

export const checkPromoCode = code => ({ type: CHECK_PROMO_CODE_REQUEST, payload: code });
export const resetPromoCode = () => ({ type: CHECK_PROMO_CODE_RESET });
